import { FuelRadio } from '@frete.com/fuel-react'
import styled from 'styled-components'

export const Radio = styled(FuelRadio)`
  margin-top: ${({ theme }) => theme.spacing.km2};
  margin-bottom: ${({ theme }) => theme.spacing.km4};
`
